import { DeleteOutlined } from "@ant-design/icons";
import { Button, Card, Space, Typography } from "antd";
import PropTypes from "prop-types";

const { Text } = Typography;

/**
 *
 * Component renders a list of editable templates of type file
 */
const FileRender = ({ fileTemplates, onRemove, isEditable }) => {
  return (
    <>
      {fileTemplates?.map((template) => (
        <FileTemplateEditorWrapper
          key={template.layout_index}
          fileTemplate={template}
          onRemove={onRemove}
          isEditable={isEditable}
        />
      ))}
    </>
  );
};

FileRender.propTypes = {
  fileTemplates: PropTypes.array,
  onRemove: PropTypes.func.isRequired,
  isEditable: PropTypes.bool,
};

// receives an editable template which contains a file
const FileTemplateEditorWrapper = ({ fileTemplate, onRemove, isEditable }) => {
  const cardActions = [];
  cardActions.push(
    <Button
      key="delete"
      name="Delete"
      type="primary"
      icon={<DeleteOutlined />}
      onClick={() => {
        onRemove(fileTemplate.layout_index);
      }}
      disabled={!isEditable}
    />
  );

  return (
    <Card
      size="small"
      title={fileTemplate.name}
      extra={cardActions}
      style={{ marginBottom: 10 }}
    >
      <Space orientation="vertical" size="middle">
        <Text>{fileTemplate.description}</Text>
      </Space>
    </Card>
  );
};

FileTemplateEditorWrapper.propTypes = {
  fileTemplate: PropTypes.object.isRequired,
  onRemove: PropTypes.func.isRequired,
  isEditable: PropTypes.bool.isRequired,
};

export default FileRender;
